import { LoadingIndicatorCircular } from '../../../components/indicators/LoadingIndicatorCircular';
import { OpenInMultiWindowButton } from '../../../components/multi-window/OpenMultiWindowButton';
import { WorkspaceWindowPanelType } from '../../../components/multi-window/types';
import useAirportSummaryUrl from '../../../hooks/use-airport-summary-url';
import { AirportSummaryIFrame } from '../../airport-summary/AirportSummaryIFrame';
import { FlyoutActions } from './Flyout';

export default function AirportSummary(props: { id: string | null }) {
    const { url, error, loading } = useAirportSummaryUrl(props.id);

    if (!url) {
        return (
            <div className="h-100 w-100 d-flex justify-content-center align-items-center">
                <LoadingIndicatorCircular />
            </div>
        );
    }

    return (
        <>
            <FlyoutActions>
                <OpenInMultiWindowButton type={WorkspaceWindowPanelType.airportSummary} airportId={props.id ?? undefined} />
            </FlyoutActions>
            {error && <div className="text-error text-center">{error}</div>}
            {loading && <LoadingIndicatorCircular />}
            {!error && url && <AirportSummaryIFrame url={url} />}
        </>
    );
}
